import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(7),
  },
  iconBtn: {
    borderRadius: '8px',
    gap: '1px',
  },
}));
